import styled from "styled-components";

export const NotificationListEmpty = styled.div`
    margin: 16px;

    text-align: center;
    color: ${({ theme }) => theme.color.grayDairyDarker};
`;
